module.exports = __webpack_public_path__ + "img/zweiterWeihnachtsbaum.f944f9d4.svg";